import React, { useState, forwardRef } from 'react';

const ViewsPopover = forwardRef((props, ref) => {
    const [viewName, setViewName] = useState('');

    const handleNewViewFormInputs = (value) => {
        setViewName(value)
    }

    return (
        <div
            ref={ref}
            className="mc-views-popover"
        >
            <div>
                <form id='mc-new-view-form' onSubmit={(e) => props.createNewView(e, viewName)}>
                    <input className='mc-new-view-name' value={viewName} type='text' placeholder='New View' onChange={(e) => handleNewViewFormInputs(e.target.value)} />
                    <button type='submit'>Create New View</button>
                </form>
            </div>
            <div className='all-mc-views-container'>
                <div className='all-mc-view-header'>My Views</div>
                {
                    props.views.map((v, i) => {
                     return <div key={`view-${i}`} className='mc-view-option' onClick={() => props.handleViewSelection(v)}>{v.name}</div>
                    })
                }
            </div>
        </div>
    )
})

export default ViewsPopover;